export const busResultsBaseRoute = 'bus-results';
